import { useId } from 'react'
import ReactSingleSelect from '~/components/react_single_select/react_single_select'
import useRetryablePostJSON from '~/hooks/use_retryable_post_json'

export function SelectWrapper({ name, label, options, selected, isLoading, onChange, id, classNamePrefix }) {
  const defaultElementId = useId()
  const elementId = id || defaultElementId

  return (
    <>
      <label htmlFor={elementId} className='form-label'>
        {label}
      </label>

      <ReactSingleSelect
        classNamePrefix={classNamePrefix}
        id={elementId}
        name={name}
        selected={selected}
        options={options}
        onChange={onChange}
        isLoading={isLoading}
      />
    </>
  )
}

export function SelectWithUrl({ name, label, url, params, selected, onChange, id, classNamePrefix }) {
  // Load options from an URL

  const initialData = []
  const response = useRetryablePostJSON({ path: url, params, initialData })
  const options = response.data
  const isLoading = response.isLoading

  return (
    <SelectWrapper
      name={name}
      label={label}
      options={options}
      isLoading={isLoading}
      selected={selected}
      onChange={onChange}
      id={id}
      classNamePrefix={classNamePrefix}
    />
  )
}

export default function Select({ name, label, options, selected, onChange, id, classNamePrefix }) {
  return (
    <SelectWrapper
      name={name}
      label={label}
      options={options}
      selected={selected}
      onChange={onChange}
      id={id}
      classNamePrefix={classNamePrefix}
      isLoading={false}
    />
  )
}
